import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ReachusService } from 'src/services/reachus.service';
import { ReachUs } from 'src/models/reachus.model';
import { Reserve } from 'src/models/reserve.model';
import { ReserveService } from 'src/services/reserve.service';
import { FormBuilder } from '@angular/forms';
import { BookingService } from 'src/services/booking.service';
import { Booking, Booking_Breakup } from 'src/models/booking.model';
import { element } from 'protractor';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bookings',
  templateUrl: './bookings.component.html',
  styleUrls: ['./bookings.component.css']
})
export class BookingsComponent implements OnInit {

  reserveResponse: string = '';
  reachus: ReachUs;
  reachusResponse: string = '';
  reserve: Reserve;
  optionValue: any = '';
  booking: Booking;
  bookingBreakup: Booking_Breakup;
  bookingCat: any;
  standardTent: any;
  familyTent: any;
  luxuryCottagesWithHillView: any;
  ExecutiveRoom: any;
  privacyPolicyResponse: any;
  termsandConditionResponse: any;
  checkOutResponse: any;
  constructor(private reachUsService: ReachusService, private router: Router,
    private formBuilder: FormBuilder, private reserveService: ReserveService,
    private bookingService: BookingService) {
    this.reachus = new ReachUs();
    this.reserve = new Reserve();
    this.booking = new Booking();
    this.bookingBreakup = new Booking_Breakup();
  }

  ngOnInit() {
    this.Get_BookingCategory();
    this.GetWhatsappNos();
  }

  WhatsappList: any[] = [];
  GetWhatsappNos() {
    let nos = (<HTMLInputElement>document.getElementById("hdnWhatsapp")).value;
    this.WhatsappList = nos.split(",");
  }
  Get_BookingCategory() {
    this.bookingService.Get_BookingCategory().subscribe(
      data => {
        var result = data;
        console.log('data>>>>', data)
        this.standardTent = result[0];
        this.familyTent = result[1];
        this.ExecutiveRoom = result[2];
        this.luxuryCottagesWithHillView = result[3]
      },
      error => {
        console.log(error);
      }
    );

  }

  bookingOption: boolean = true;
  bookingdisabled: boolean = true;
  ApplyForBooking(type: string) {
    const url = 'https://www.swiftbook.io/inst/#home?propertyId=681N5iT4UHFuXX2BDYDTmTxucsxRszGYeDXsHhTQxMjk=&JDRN=Y';
    window.open(url, '_blank');
  }


  checkInResponse: any = "";
  CheckInDateChange() {
    this.checkInResponse = "";
    this.booking.Check_Out_Date = null;
    var date1 = new Date();
    var date2 = new Date(this.booking.Check_In_Date);

    // To calculate the time difference of two dates 
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates 
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
    if (Difference_In_Days <= 0) {
      this.checkInResponse = "Check-In date must be greater than Current Date"
      this.booking.Check_In_Date = null;
    }
  }

  CheckOutDateChange() {
    this.checkInResponse = "";
    var d11 = this.booking.Check_In_Date;
    // = new Date((document.getElementById("datepicker") as HTMLInputElement).value);
    var d22 = this.booking.Check_Out_Date;//

    var date1 = new Date(this.booking.Check_In_Date);
    var date2 = new Date(this.booking.Check_Out_Date);

    // To calculate the time difference of two dates 
    var Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates 
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    //To display the final no. of days (result) 
    // console.log("Total number of days between dates  <br>" + date1 + "<br> and <br>" + date2 + " is: <br> " + Difference_In_Days);

    if (Difference_In_Days <= 0) {
      this.checkInResponse = "Checkout date must be greater than Check-In Date";
      this.booking.Check_Out_Date = null;
      this.booking.No_Of_Nights = 0;
    }
    else {
      this.booking.No_Of_Nights = Difference_In_Days;
    }
  }

  Total_Extra_Bed_tax: any;
  ExtraBedChange() {
    this.Total_Extra_Bed_tax = ((this.booking.Extra_Bed * this.booking.Extra_Bed_Rate) * this.booking.No_Of_Nights) * 12 / 100;
    this.booking.Extra_Bed_Price = ((this.booking.Extra_Bed * this.booking.Extra_Bed_Rate) * this.booking.No_Of_Nights);
  }

  Total_Meal_tax: any;
  AdultMealChange() {
    this.Total_Meal_tax = ((this.booking.Adult_Meal * this.booking.Adult_Meal_Rate) * this.booking.No_Of_Nights) * 5 / 100;
    this.booking.Adult_Meal_Price = ((this.booking.Adult_Meal * this.booking.Adult_Meal_Rate) * this.booking.No_Of_Nights);
  }

  AddBookingBreakup() {
    if (this.booking.Check_In_Date == undefined || this.booking.Check_In_Date == null) {
      this.checkInResponse = "Please select CheckIn Date";
      return true;
    }
    if (this.booking.Check_Out_Date == undefined || this.booking.Check_Out_Date == null) {
      this.checkInResponse = "Please select CheckOut Date";
      return true;
    }

    this.booking.Booking_Breakup.push(this.bookingBreakup);
    this.bookingBreakup = new Booking_Breakup();
  }

  RemoveBookingBreakup(item) {
    var index = this.booking.Booking_Breakup.indexOf(item);
    this.booking.Booking_Breakup.splice(index, 1);
  }

  Total_Room_tax: any;
  CalculateAmount() {
    if (this.booking.Booking_Breakup.length == 0) {
      this.AddBookingBreakup();
    }
    this.booking.Booking_Breakup.forEach(element => {
      this.booking.No_Of_Adult = 0;
      this.booking.No_Of_Child = 0;
      this.booking.No_Of_Adult += parseInt(element.Adult.toString());
      this.booking.No_Of_Child += parseInt(element.Child.toString());
    });

    this.booking.No_Of_Booking = this.booking.Booking_Breakup.length;
    this.Total_Room_tax = ((this.bookingCat["Final_Price"].toFixed(2) * this.booking.No_Of_Nights) * this.booking.No_Of_Booking) * 12 / 100;
    this.booking.Price = ((this.bookingCat["Final_Price"].toFixed(2) * this.booking.No_Of_Nights) * this.booking.No_Of_Booking);
    this.booking.Combined_Price = this.booking.Price + this.booking.Extra_Bed_Price + this.booking.Adult_Meal_Price + this.booking.Child_Meal_Price;

    this.booking.Taxes_Amount = this.Total_Meal_tax + this.Total_Extra_Bed_tax + this.Total_Room_tax;
    this.booking.Final_Price = this.booking.Combined_Price + this.booking.Taxes_Amount;

  }

  //#region Form Validation
  NameResponse: any;
  EmailResponse: any;
  PhoneResponse: any;
  PaymentResponse: any;

  validations() {
    if (this.booking.Guest_Name == '' || this.booking.Guest_Name == undefined) {
      this.NameResponse = 'Name is Required';
      return true;
    }
    if (this.booking.Email == '' || this.booking.Email == undefined) {
      this.EmailResponse = 'Email is Required';
      return true;
    }
    if (this.booking.Phone_No == '' || this.booking.Phone_No == undefined) {
      this.PhoneResponse = 'Phone No. is Required';
      return true;
    }
    if (this.booking.Payment_Mode == '' || this.booking.Payment_Mode == undefined) {
      this.PaymentResponse = 'Payment Option is Required';
      return true;
    }

    if (!this.validatePhone(this.booking.Phone_No)) {
      return true;
    }

  }
  //#endregion

  //#region Email
  ValidateEmail(email: string) {
    var regularExpression = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    var valid = regularExpression.test(email) //match a letter _and_ a number
    if (!valid) {
      this.EmailResponse("Please enter valid Email ID");
      return false;
    }
    else {
      return true;
    }
  }
  //#endregion

  //#region Phone no. validation
  validatePhone(phone: any) {
    if (phone.length < 10) {
      this.PhoneResponse = "Please enter valid Phone Number"
      return true;
    }
  }
  //#endregion

  save() {
    debugger;
    this.NameResponse = '';
    this.EmailResponse = '';
    this.PhoneResponse = '';
    this.PaymentResponse = '';
    if (this.validations()) {
      return;
    }
    debugger;
    this.reserveResponse = '';
    this.booking.Status = 'Entry Created';
    this.reserveService.Save(this.booking).subscribe(
      data => {
        var result = data;
        console.log(data);
        this.reserveResponse = "Your request has been submitted. Our executive will call you soon.";
        this.booking = new Booking();
      },
      error => {
        console.log(error);
      }
    );

  }

  // save() {
  //   debugger;
  //   this.reserveResponse = '';

  //   if (!this.reserve.Name) {
  //     this.reserveResponse = "Enter The Name";
  //     return;
  //   }
  //   if (!this.reserve.LastName) {
  //     this.reserveResponse = "Enter The Last Name";
  //     return;
  //   }
  //   if (!this.reserve.Email) {
  //     this.reserveResponse = "Enter The Email";
  //     return;
  //   }
  //   if (!this.reserve.PhoneNo) {
  //     this.reserveResponse = "Enter The Phone No";
  //     return;
  //   }
  //   if (!this.reserve.Accommodation) {
  //     this.reserveResponse = "Select Accommodation Preferred";
  //     return;
  //   }
  //   if (!this.reserve.VisitingTime) {
  //     this.reserveResponse = "Select Stay Period";
  //     return;
  //   }
  //   if (!this.reserve.Member) {

  //     this.reserveResponse = "Select No. Of Adults";
  //     return;
  //   }
  //   if (!this.reserve.Member) {

  //     this.reserveResponse = "Select No. Of Children";
  //     return;
  //   }

  //   debugger;
  //   this.reserve.VisitingDate = new Date((document.getElementById("datepicker") as HTMLInputElement).value);
  //   this.reserve.VisitingDate = new Date((document.getElementById("datepicker2") as HTMLInputElement).value);

  //   if (!this.reserve.VisitingDate) {
  //     this.reserveResponse += "Select CheckIn Date";
  //     return;
  //   }
  //   if (!this.reserve.CheckOutDate) {
  //     this.reserveResponse += "Select CheckOut Date";
  //     return;
  //   }
  //   if (!this.reserve.Message) {
  //     this.reserveResponse = "Enter The Message";
  //     return;
  //   }

  //   if (!this.reserve.Captcha) {
  //     this.reserveResponse = "Please verify you are human!";
  //     return;
  //   }

  //   this.reserveService.Save(this.reserve).subscribe(
  //     data => {
  //       var result = data;
  //       console.log(data);
  //       grecaptcha.reset(1);
  //       this.reserveResponse = "Your request has been submitted. Our executive will call you soon.";
  //       this.reserve = new Reserve();
  //     },
  //     error => {
  //       console.log(error);
  //     }
  //   );

  // }

  onCaptchaClick(captchaResponse: string) {
    this.reachus.Captcha = captchaResponse;
    console.log(`Resolved response token: ${captchaResponse}`);
  }

}


